import { render } from "./AchievementsPage.vue?vue&type=template&id=bcf60d30&scoped=true"
import script from "./AchievementsPage.vue?vue&type=script&lang=js"
export * from "./AchievementsPage.vue?vue&type=script&lang=js"

import "./AchievementsPage.vue?vue&type=style&index=0&id=bcf60d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf60d30"]])

export default __exports__